module.exports = __webpack_public_path__ + "img/1.c567494a.jpg";